import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TimeFormat } from '@app/core/_models'

@Component({
    selector: 'fm-calendar-timeslot-labels',
    imports: [],
    templateUrl: './timeslot-labels.component.html',
    styleUrl: './timeslot-labels.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeslotLabelsComponent {
    @Input() timeFormat: TimeFormat
    public timeslots: string[] = []

    constructor() {}

    ngOnInit() {
        this.generateTimeslots()
    }

    private generateTimeslots() {
        this.timeslots = []
        const start = 0 // Start at midnight
        const end = 24 * 4 // 24 hours * 4 slots per hour = 96 slots

        for (let i = start; i < end; i++) {
            const hour = Math.floor(i / 4)
            const minutes = (i % 4) * 15
            const timeString =
                this.timeFormat === '12hr'
                    ? this.formatTime12Hour(hour, minutes)
                    : this.formatTime24Hour(hour, minutes)
            this.timeslots.push(timeString)
        }
    }

    private formatTime12Hour(hour: number, minutes: number): string {
        const period = hour < 12 ? 'am' : 'pm'
        const adjustedHour = hour % 12 === 0 ? 12 : hour % 12
        if (minutes) {
            return `:${this.padTime(minutes)}`
        }
        return `${adjustedHour}${period}`
    }

    private formatTime24Hour(hour: number, minutes: number): string {
        if (minutes) {
            return `:${this.padTime(minutes)}`
        }
        return `${this.padTime(hour)}:${this.padTime(minutes)}`
    }

    private padTime(value: number): string {
        return value.toString().padStart(2, '0')
    }
}
